import { render, staticRenderFns } from "./Normativity.vue?vue&type=template&id=03548af5&lang=pug&"
import script from "./Normativity.vue?vue&type=script&lang=js&"
export * from "./Normativity.vue?vue&type=script&lang=js&"
import style0 from "./Normativity.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src142773959/src/bsix_meet_client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03548af5')) {
      api.createRecord('03548af5', component.options)
    } else {
      api.reload('03548af5', component.options)
    }
    module.hot.accept("./Normativity.vue?vue&type=template&id=03548af5&lang=pug&", function () {
      api.rerender('03548af5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/virtualrowFSFB/Normativity.vue"
export default component.exports